import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

const getEnvelopeCertificateUrl = async (
  envelopeId: string,
): Promise<string> => {
  const response = await apiClient.get(
    `/v1/ecm/envelopes/${envelopeId}/certificate`,
    { responseType: 'blob' },
  )
  const blob = new Blob([response.data as BlobPart], {
    type: 'application/pdf',
  })
  return URL.createObjectURL(blob)
}

export const useGetEnvelopeCertificate = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => getEnvelopeCertificateUrl(envelopeId),
    meta: {
      skipErrorMessage: true,
      ...feedback,
    },
  })
}
